import React from 'react';
import PropTypes from 'prop-types';

import {Box, Divider, Stack, Typography, Skeleton, Link} from 'views/components';

import {HoverToolBox, Translate} from 'views/module';

import backend from 'utils/backend';

const CaregiverView = (props) => {
  const [clientData, setClientData] = React.useState(null);

  const [toolbarVisible, setToolbarVisible] = React.useState(false);
  const [mouseOver, setMouseOver] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const caregiver = props.caregiver;
  const removeCaregiver = props.removeCaregiver;

  React.useEffect(() => {
    setToolbarVisible(mouseOver);
  }, [mouseOver]);

  // Load caregiver data
  React.useEffect(() => {
    backend.caregiver.getCaregiver(caregiver.caregiverRn, true)
        .then((e) => {
          setClientData(e);
        })
        .catch(() => {
          console.error('Failed to load caregiver data');
        });
  }, [caregiver]);

  return (
    <Box>
      <Divider/>
      <Box
        onMouseOver={(e) => setMouseOver(true) & setAnchorEl(e.currentTarget)}
        onMouseLeave={(e) => setMouseOver(false)}
        sx={{
          backgroundColor: toolbarVisible ? 'background.highlighted': 'inherit',
          p: 2,
        }}
      >
        <Stack>
          <Typography
            sx={{
              fontWeight: 600,
            }}
          >
            <Translate expression='client.ClientDetail.CaregiverConnections.Caregiver.CaregiverName'/>
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
            }}
          >
            {clientData ? (
                <Link href={`/caregiver/${clientData.caregiverRn}`}>
                  {clientData.caregiverDetail.caregiverName}
                </Link>
              ) : (
                <Skeleton sx={{fontSize: '14px', width: '100px'}} />
              )}
          </Typography>
        </Stack>
        <HoverToolBox
          toolBar={toolbarVisible}
          anchorEl={anchorEl}
          onClickDelete={() => removeCaregiver(caregiver.caregiverRn)}
          hideTool={{
            emoji: true,
            copy: true,
            edit: true,
            delete: false,
          }}
        />
      </Box>
    </Box>
  );
};

CaregiverView.propTypes = {
  caregiver: PropTypes.object.isRequired,
  removeCaregiver: PropTypes.func.isRequired,
};

export default React.memo(CaregiverView);
